import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import HeroBanner from '~/containers/HeroBanner';
import Container from '~/components/Container';
import IconSearchBlack from '~/components/svg/icon-search-black.svg';
import IconSearchWhite from '~/components/svg/icon-search-white.svg';
import themeVariables from '~/shared/themeVariables';

class MenuOption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleClickOption = (value) => {
    const { handleClickOption } = this.props;
    handleClickOption(value);
  };
  render() {
    const { t, option } = this.props;
    return (
      <Container>
        <div className="menu-container">
          <div
            className={`option editing-tools ${option === 0 ? 'active' : ''}`}
            onClick={() => this.handleClickOption(0)}
          >
            <div className="text">{t('ai_landing_page_menu_01')}</div>
            <div className="icon">
              {option === 0 ? (
                <img
                  src={`${Config.staticPrefix}/static/images/icon-search-white.png`}
                  alt="icon-search"
                  width="16px"
                />
              ) : (
                <img
                  src={`${Config.staticPrefix}/static/images/icon-search-black.png`}
                  alt="icon-search"
                  width="16px"
                />
              )}
            </div>
          </div>
          <div
            className={`option generation-tools ${
              option === 1 ? 'active' : ''
            }`}
            onClick={() => this.handleClickOption(1)}
          >
            <div className="text">{t('ai_landing_page_menu_02')}</div>
            <div className="icon">
              {option === 1 ? (
                <img
                  src={`${Config.staticPrefix}/static/images/icon-search-white.png`}
                  alt="icon-search"
                  width="16px"
                />
              ) : (
                <img
                  src={`${Config.staticPrefix}/static/images/icon-search-black.png`}
                  alt="icon-search"
                  width="16px"
                />
              )}
            </div>
          </div>
          <div
            className={`option other-tools ${option === 2 ? 'active' : ''}`}
            onClick={() => this.handleClickOption(2)}
          >
            <div className="text">{t('ai_landing_page_menu_03')}</div>
            <div className="icon">
              {option === 2 ? (
                <img
                  src={`${Config.staticPrefix}/static/images/icon-search-white.png`}
                  alt="icon-search"
                  width="16px"
                />
              ) : (
                <img
                  src={`${Config.staticPrefix}/static/images/icon-search-black.png`}
                  alt="icon-search"
                  width="16px"
                />
              )}
            </div>
          </div>
        </div>
        <style jsx>
          {`
            .menu-container {
              width: 100%;
              display: flex;
              gap: 24px;
            }
            .option {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              text-align: center;
              width: fit-content;
              height: 58px;
              // background: #c4c4c4;
              color: #1b2833;
              font-weight: 500;
              cursor: pointer;
              border: 1px solid #1b2833;
              box-sizing: border-box;
              border-radius: 100px;
              padding-left: 16px;
              padding-right: 16px;
              gap: 12px;
            }
            .option:hover {
              background: #c4c4c4;
            }
            .option.active {
              // opacity: 1;
              background: #1b2833;
              color: #ffffff;
            }
            .icon {
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              margin-left: 8px;
            }
            @media (max-width: ${themeVariables.breakpoints.tabletL
                .maxWidth}px) {
              .menu-container {
                width: 100%;
                display: flex;
              }
              .option {
                font-size: 16px;
              }
              .text {
                width: 100%;
              }
            }
            @media (max-width: ${themeVariables.breakpoints.tabletS
                .maxWidth}px) {
              .option {
                font-size: 14px;
              }
              .text {
                width: 100%;
              }
            }
            @media (max-width: ${themeVariables.breakpoints.mobile
                .maxWidth}px) {
              .menu-container {
                display: flex;
                gap: 12px;
                flex-wrap: wrap;
              }
              .text {
                width: 100%;
                font-size: 12px;
              }
              .icon {
                margin-left: 0px;
              }
              .option {
                gap: 4px;
              }
              .other-tools {
                min-width: 102px;
              }
              .generation-tools {
                min-width: 120px;
              }
              .editing-tools {
                min-width: 120px;
              }
            }
          `}
        </style>
      </Container>
    );
  }
}

export default MenuOption;
